export default __webpack_public_path__ + "static/media/Calvin.a8403d37.jpeg";